import { Col, Row, Card } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

import { IconPerson } from "../../common/icons";
import { eSalaryImage } from "../../common/utils";
import { authSelector } from "../../reducers";
import { useCurrentUser } from "../../hooks/useCurrentUser.ts";

export function PersonalSupervisor() {
  const { t } = useTranslation();
  const { eSalaryCompanyId } = useSelector(authSelector);

  const currentUser = useCurrentUser();
  const supervisor = currentUser?.controlDetails?.supervisor;

  return (
    <>
      <h4 style={{ color: "var(--heeros-blue)" }}>{t("PersonalSupervisor", "Esihenkilöni")}</h4>

      <Row className="mt-4-5">
        <Col>
          {currentUser && (
            <Card className="p-3 d-flex flex-row align-items-center shadow-sm rounded-3 supervisor-card">
              {supervisor?.image ? (
                <img
                  src={eSalaryImage(eSalaryCompanyId, supervisor.image)}
                  crossOrigin="anonymous"
                  alt={supervisor.personName}
                  className="rounded-circle me-3"
                  width={50}
                  height={50}
                  style={{ objectFit: "cover" }}
                />
              ) : (
                <IconPerson className="supervisor-icon" />
              )}

              <div className="supervisor-text-wrapper">
                {supervisor ? (
                  <>
                    <div className="supervisor-name">{supervisor.personName}</div>
                    <div className="supervisor-info supervisor-info-underline">{supervisor.email || ""}</div>
                    <div className="supervisor-info">{supervisor.tel || ""}</div>
                  </>
                ) : (
                  <div className="text-muted fst-italic">
                    {t("NoSupervisorFound", "Esihenkilöä ei ole määritelty.")}
                  </div>
                )}
              </div>
            </Card>
          )}
        </Col>
      </Row>
    </>
  );
}
